import React from 'react';
import { Message } from 'semantic-ui-react';

export default () => (
  <div>
    <Message.Header>Values &amp; Vision</Message.Header>
    <Message.List>
      <Message.Item>
        The firm and its members excel on the exemplary values and are committed
        to Quality, Integrity and Professional Due Diligence.
      </Message.Item>
      <Message.Item>
        Confidentiality, Credibility, Personal Attention &amp; Customized
        Consultancy, Building &amp; Maintaining Relations through Client
        Satisfaction and Corporate Social Responsibility upholding high
        standards of service and integrity, in our pursuit of excellence.
      </Message.Item>
    </Message.List>
  </div>
);
